import { render } from "./balkenMitBildZuhehoer.vue?vue&type=template&id=af212ff2"
import script from "./balkenMitBildZuhehoer.vue?vue&type=script&lang=js"
export * from "./balkenMitBildZuhehoer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__